<div class="flex flex-col items-center gap-3 w-full">
  <!-- Header row -->
  <div class="flex items-center gap-3 w-full">
    <app-icon-badge
      content="icons/creators.svg"
      backgroundColor="var(--shikenso-pink-100-12)"
      color="var(--shikenso-purple-base)"
      alt="creators"
      [iconSize]="24"
      [size]="44"
    />

    <div class="flex flex-col flex-1 min-w-0">
      <span class="text-lg">{{ 'pages.campaignForm.sections.creatorsAndCtas.creatorsLabel' | translate }}</span>
      <span class="text-shikenso-purple-base-60 text-sm">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorsDescription' | translate }}
      </span>
    </div>

    <button
      mat-flat-button
      type="button"
      color="secondary-white"
      class="mat-slim-plus-button"
      (click)="addCreatorClick.emit()"
    >
      <div class="flex items-center gap-1">
        <app-icon src="icons/plus.svg" [size]="16" />
        {{ 'pages.campaignForm.sections.creatorsAndCtas.addCreator' | translate }}
      </div>
    </button>
  </div>

  <!-- Count badge + expand/collapse -->
  @if (creatorsCount() > 0) {
    <div class="flex items-center justify-between w-full">
      <span class="text-[10px] bg-shikenso-pink-100-24 text-shikenso-purple-base rounded-full px-2">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorsCount' | translate: { count: creatorsCount() } }}
      </span>

      <button
        mat-flat-button
        type="button"
        color="secondary-gray"
        class="mat-tiny-button"
        (click)="expandCollapseAll()"
      >
        <span class="text-xs">
          {{
            allExpanded()
              ? ('pages.campaignForm.sections.creatorsAndCtas.collapseAll' | translate)
              : ('pages.campaignForm.sections.creatorsAndCtas.expandAll' | translate)
          }}
        </span>
      </button>
    </div>

    <!-- Creator expansion panels -->
    <div class="flex flex-col gap-3 w-full">
      @for (campaignCreator of campaignCreatorsValue(); track campaignCreator.creatorId) {
        @let creatorId = campaignCreator.creatorId ?? '';
        <app-creator-summary-panel
          [campaignCreator]="campaignCreator"
          [campaign]="campaign()"
          [ctasShareCountMap]="ctasShareCountMap()"
          [creatorHasCustomValueMap]="creatorHasCustomValueMap()"
          [getExistingDeliverablesCount]="getExistingDeliverablesCount()"
          [getExistingExecutionsCount]="getExistingExecutionsCount()"
          [getExistingKpisCount]="getExistingKpisCount()"
          [hasCreatorBriefingNote]="creatorBriefingNoteMap().get(creatorId) ?? false"
          [isNew]="newlyAddedCreatorIds().includes(creatorId)"
          (addPayoutClick)="editPayoutClick.emit(creatorId)"
          (deleteCreatorClick)="deleteCreatorClick.emit(creatorId)"
          (briefingNoteClick)="briefingNoteClick.emit(creatorId)"
          (addIndividualGroupClick)="addIndividualGroupClick.emit(creatorId)"
          (addDeliverablesForCta)="
            addDeliverablesForCta.emit({ creatorId: creatorId, ctaId: $event.ctaId, step: $event.step })
          "
          (editCtaName)="editCtaName.emit({ creatorId: creatorId, ctaId: $event })"
          (editCtaGroup)="editCtaGroup.emit({ creatorId: creatorId, ctaId: $event })"
          (removeCtaFromCreator)="
            removeCtaFromCreator.emit({
              creatorId: creatorId,
              ctaId: $event.ctaId,
              isAllCreators: $event.isAllCreators,
            })
          "
          (copyCtaForCreator)="copyCtaForCreator.emit({ ctaId: $event, creatorId: creatorId })"
          (copyCta)="copyCta.emit($event)"
        />
      }
    </div>
  }
</div>
